import { render, staticRenderFns } from "./SuspendedWarning.vue?vue&type=template&id=04485a1a&scoped=true"
import script from "./SuspendedWarning.vue?vue&type=script&lang=js"
export * from "./SuspendedWarning.vue?vue&type=script&lang=js"
import style0 from "./SuspendedWarning.vue?vue&type=style&index=0&id=04485a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04485a1a",
  null
  
)

export default component.exports